import { CheckoutState } from '../../../state';
import { getSurvey } from './getSurvey';

export const getHasPreOrderConfirmationQuestions = (
    state: CheckoutState,
): boolean => {
    const survey = getSurvey(state);
    return Boolean(survey?.preOrderConfirmationSurveySettings?.hasQuestions);
};
